import { css } from '@emotion/css';

export const iconButton = css`
  width: 16px !important;
  height: 16px !important;
`;

export const grabCursor = css`
  cursor: grab;
`;

export const zIndex15 = css`
  z-index: 15;
`;
